<div class="oase-kontaktformular" fxLayout="column" fxLayoutGap="20px">
    <mat-card appearance="raised">
        <mat-card-title>
            {{ OBJ_LNG_NAME+'.titel' | translate:locale.language }}
            <p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
        </mat-card-title>
        <mat-card-subtitle>{{ OBJ_LNG_NAME+'.beschreibung' | translate:locale.language }}</mat-card-subtitle>
        <mat-card-content>
            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                <div>
                    <mat-form-field appearance="fill" fxFlex="70">
                        <mat-label>{{ OBJ_LNG_NAME+'.betreff' | translate:locale.language }}</mat-label>
                        <input matInput formControlName="subject" required>
                        <mat-hint *ngIf="subject.touched && !subject.valid">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.betreff' | translate:locale.language } }}</mat-hint>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="fill" fxFlex="100">
                        <mat-label>{{ OBJ_LNG_NAME+'.nachricht' | translate:locale.language }}</mat-label>
                        <textarea matInput formControlName="message" required cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="5" cdkAutosizeMaxRows="15"></textarea>
                        <mat-hint *ngIf="nachricht.touched && !nachricht.valid">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.nachricht' | translate:locale.language } }}</mat-hint>
                    </mat-form-field>
                </div>
                <div *ngIf="files">
                    {{ OBJ_LNG_NAME+'.dateiliste' | translate:locale.language }}
                    <ul>
                        <li *ngFor="let currentFile of files; let currentIndex=index">{{ currentFile.name }} <button mat-icon-button (click)="deleteFile(currentIndex)" matTooltip="{{ 'allgemein.klick.löschen' | translate:locale.language:{ bestimmt: OBJ_LNG_NAME+'.bestimmt' | translate:locale.language, typ: OBJ_LNG_NAME+'.dateityp' | translate:locale.language } }}"><mat-icon>delete</mat-icon></button></li>
                    </ul>
                </div>
                <div class="oase-buttons">
                    <input #fileInput id="fileInput" class="oase-hideme" type="file" accept=".pdf, .doc, .docx, image/jpeg" (change)="onFileSelected($event)" multiple>
                    <button mat-raised-button color="primary" (click)="triggerFileClick()" type="button">
                        {{ OBJ_LNG_NAME+'.upload' | translate:locale.language }}
                    </button>
                </div>
            </form>
        </mat-card-content>
        <mat-card-actions align="end">
            <button mat-raised-button type="button" color="primary" [disabled]="!contactForm.valid" (click)="onSubmit()">{{ OBJ_LNG_NAME+'.senden' | translate:locale.language }}</button>
        </mat-card-actions>
    </mat-card>
</div>